import { type FC } from "react";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";
import { LensIcon } from "../../common/components";

type LensPreviewProps = {
    source?: string;
    iconUrl: string;
    previewUrl: string;
    videoUrl: string;
};

export const LensPreview: FC<LensPreviewProps> = ({ source, iconUrl, videoUrl, previewUrl }) => {
    const isMarketPlaceRoute = false;
    return (
        <LensPreviewContainer>
            <LensPreviewBorder>
                {videoUrl ? (
                    <LensPreviewVideo loop muted autoPlay src={videoUrl} poster={previewUrl ?? iconUrl} />
                ) : (
                    <LensPreviewWithIcon backgroundUrl={iconUrl} />
                )}
            </LensPreviewBorder>
            <AbsoluteLensIcon size={64} src={iconUrl} source={isMarketPlaceRoute ? "" : source} isOnPreview={true} />
        </LensPreviewContainer>
    );
};

const LensPreviewContainer = styled.div`
    position: relative;

    flex: 0;

    min-width: 142px;
    max-width: 160px;
    height: 250px;
    margin-bottom: 8px;
`;

const LensPreviewBorder = styled.div`
    overflow: hidden;

    width: 100%;
    height: 100%;

    border-radius: 16px;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 20%);
`;

const LensPreviewWithIcon = styled.div<{ backgroundUrl?: string }>`
    width: 100%;
    height: 100%;
    background: center/cover no-repeat url(${({ backgroundUrl }) => backgroundUrl});
    filter: blur(3px);
`;

const LensPreviewVideo = styled.video`
    width: 100%;
    height: auto;
`;

const AbsoluteLensIcon = styled(LensIcon)`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 30%);

    border: 5.5px solid ${Colors.Gray.V100};
    border-radius: 50%;
`;
